function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M90.1221 71.2479C89.2146 71.2422 88.4556 70.8186 87.712 70.0529L87.9774 68.5954C88.7029 69.3275 89.48 69.8977 90.1422 69.8996C90.7613 69.9015 91.6535 69.4684 91.6592 68.2858C91.6678 66.0482 87.597 66.3079 87.6114 63.0334C87.6181 61.3602 88.9999 60.1691 90.4422 60.1738C91.3689 60.1777 91.9984 60.5696 92.7565 61.4465L92.2802 62.6779C91.78 62.1086 91.1187 61.5222 90.47 61.5193C89.643 61.5155 89.0076 62.2275 89.0067 63.02C88.9942 65.1599 93.066 64.904 93.0535 68.1957C93.0449 70.1229 91.5653 71.2537 90.1221 71.2479Z",
  fill: "#BBD422"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M98.8441 63.3255C98.8479 62.12 98.2518 61.5508 97.5063 61.5488C96.7607 61.545 96.158 62.1095 96.1532 63.3112L96.1426 65.7414L98.8335 65.7529L98.8441 63.3255ZM96.1235 71.1404L94.7617 71.1366L94.7924 63.3064C94.7991 61.292 96.0209 60.1967 97.5111 60.2034C99.0031 60.2091 100.216 61.315 100.209 63.3265L100.177 71.1558L98.8124 71.1529L98.8287 67.0983L96.1397 67.0888L96.1235 71.1404Z",
  fill: "#BBD422"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M106.688 60.3674L107.902 60.3741L107.86 71.1904L106.853 71.1856L103.691 64.0051L103.66 71.1712L102.445 71.1664L102.487 60.353L103.493 60.3569L106.658 67.5355L106.688 60.3674Z",
  fill: "#BBD422"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M109.225 61.7414L109.232 60.3796L115.182 60.4026L115.178 61.7653L112.876 61.7558L112.837 71.2074L111.492 71.2026L111.53 61.751L109.225 61.7414Z",
  fill: "#BBD422"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M117.75 59.4569L117.376 59.0668L119.872 55.8354L121.001 56.9729L117.75 59.4569ZM116.511 60.4094L120.564 60.4257L120.561 61.7865L117.87 61.7759L117.857 64.4687L120.549 64.4774L120.542 65.8401L117.853 65.8286L117.834 69.8831L120.528 69.8937L120.521 71.2382L116.467 71.2238L116.511 60.4094Z",
  fill: "#BBD422"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M2.5079 71.0264C1.6004 71.0226 0.839511 70.6 0.100664 69.8343L0.366102 68.3786C1.09057 69.1069 1.86489 69.6781 2.52994 69.68C3.14421 69.6838 4.03447 69.2507 4.04022 68.0691C4.0498 65.8363 -0.0143364 66.0931 3.80411e-05 62.8243C0.00770441 61.1569 1.38765 59.9648 2.82797 59.9724C3.74985 59.9763 4.38041 60.3673 5.13747 61.2412L4.66407 62.4717C4.1648 61.9015 3.50262 61.3169 2.85481 61.3131C2.02971 61.3102 1.3934 62.0203 1.39245 62.8138C1.38286 64.9498 5.44603 64.693 5.43166 67.9761C5.42687 69.9052 3.94727 71.0322 2.5079 71.0264Z",
  fill: "#BBD422"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M8.79771 60.1268L8.76608 67.9609C8.75937 69.1406 9.35736 69.7089 10.101 69.7127C10.8456 69.7146 11.4484 69.155 11.4522 67.9724L11.4838 60.1383L12.8427 60.1431L12.8139 67.9772C12.8034 69.9638 11.5873 71.0629 10.0972 71.0572C8.6118 71.0505 7.40147 69.9436 7.40626 67.9552L7.43884 60.1211L8.79771 60.1268Z",
  fill: "#BBD422"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M16.7588 65.5612L17.8244 65.5651C18.96 65.5708 19.8551 64.671 19.8589 63.5517C19.8647 62.4199 18.9763 61.5268 17.8417 61.522L16.7761 61.5182L16.7588 65.5612ZM16.7368 70.9526L15.377 70.9488L15.421 60.1536L17.8484 60.1612C19.7085 60.1699 21.2254 61.6955 21.2187 63.5584C21.2101 65.4204 19.6826 66.9191 17.8197 66.9105L16.7521 66.9076L16.7368 70.9526Z",
  fill: "#BBD422"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M22.9581 60.1833L27.006 60.1996L26.9993 61.5575L24.3113 61.5499L24.3017 64.235L26.9887 64.2446L26.983 65.6035L24.295 65.592L24.2777 69.6408L26.9677 69.6523L26.96 70.9939L22.9141 70.9786L22.9581 60.1833Z",
  fill: "#BBD422"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M30.8506 65.6198L31.6623 65.6226C32.7778 65.6265 33.6872 64.7257 33.691 63.6083C33.6948 62.4765 32.7921 61.5834 31.6776 61.5777L30.8659 61.5748L30.8506 65.6198ZM35.3795 71.0284L33.92 71.0226L32.2708 66.9211C32.0763 66.9518 31.8654 66.969 31.6556 66.9671L30.8449 66.9642L30.8286 71.0092L29.4688 71.0025L29.5109 60.2083L31.6824 60.2178C33.5406 60.2255 35.0412 61.7521 35.0355 63.6131C35.0288 64.7803 34.426 65.797 33.5329 66.4065L35.3795 71.0284Z",
  fill: "#BBD422"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M38.6228 71.0407L37.3262 71.0369L37.3722 60.2417L38.6994 60.2474L40.7339 65.4826L42.7932 60.2647L44.1215 60.2685L44.0783 71.0628L42.799 71.059L42.8287 63.5162L40.8508 68.4936L40.5758 68.4917L38.6525 63.4989L38.6228 71.0407Z",
  fill: "#BBD422"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M50.8041 63.2747C50.8108 62.0758 50.2119 61.5076 49.4692 61.5037C48.7236 61.4999 48.1218 62.0663 48.117 63.2632L48.1084 65.6896L50.7945 65.7001L50.8041 63.2747ZM48.0873 71.079L46.7246 71.0723L46.7562 63.2584C46.7639 61.2507 47.9838 60.1554 49.473 60.1612C50.9632 60.165 52.1716 61.2718 52.162 63.2795L52.1294 71.0963L50.7715 71.0915L50.7878 67.0456L48.1007 67.0341L48.0873 71.079Z",
  fill: "#BBD422"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M56.1377 65.7214L56.9446 65.7252C58.0629 65.729 58.9733 64.8273 58.9781 63.7099C58.9819 62.5781 58.0783 61.685 56.9638 61.6812L56.1559 61.6773L56.1377 65.7214ZM60.6618 71.13L59.2062 71.1252L57.557 67.0256C57.3615 67.0543 57.1506 67.0697 56.9417 67.0697L56.1329 67.0649L56.1166 71.1108L54.7559 71.1051L54.799 60.3118L56.9686 60.3223C58.8296 60.3271 60.3312 61.8556 60.3236 63.7166C60.3169 64.8828 59.716 65.8986 58.8209 66.5091L60.6618 71.13Z",
  fill: "#BBD422"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M64.9951 60.2246C66.3194 60.2304 67.0592 61.1551 67.5738 62.2888L66.7123 62.9989C66.4076 62.3511 65.939 61.7167 65.1158 61.7129C63.9036 61.7081 63.3621 63.4704 63.3535 65.7502C63.343 68.0165 63.871 69.8018 65.0842 69.8066C65.9083 69.8086 66.3808 69.1636 66.6903 68.5177L67.5451 69.2489C67.0228 70.3797 66.2753 71.2824 64.9471 71.2776C62.9089 71.269 61.849 68.7554 61.8614 65.7435C61.8739 62.7229 62.9539 60.216 64.9951 60.2246Z",
  fill: "#BBD422"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M73.0444 64.4323L73.0598 60.3864L74.4205 60.3902L74.3774 71.1854L73.0176 71.1806L73.0387 65.7893L70.3526 65.7787L70.3324 71.1691L68.9707 71.1653L69.0148 60.3691L70.3756 60.3739L70.3574 64.4208L73.0444 64.4323Z",
  fill: "#BBD422"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M78.2774 59.4521L77.9095 59.063L80.3982 55.8354L81.5251 56.972L78.2774 59.4521ZM77.0451 60.4027L81.092 60.4199L81.0853 61.7778L78.4011 61.7683L78.3886 64.4544L81.0728 64.464L81.069 65.8228L78.3838 65.8123L78.3675 69.8601L81.0536 69.8707L81.0479 71.2142L77.002 71.1969L77.0451 60.4027Z",
  fill: "#BBD422"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4783 24.6248C11.0529 24.6248 7.60808 29.5389 7.60808 35.4892C7.60808 41.4407 11.054 46.3614 15.4783 46.3614C19.9026 46.3614 23.411 41.4407 23.411 35.4892C23.4121 29.5389 19.9026 24.6248 15.4783 24.6248ZM28.2258 52.3798L25.496 47.2706C22.7662 50.895 18.9767 52.3798 14.616 52.3798C6.48695 52.3798 0.13052 45.2637 0 35.4892C0 25.7237 6.50145 17.8914 14.6316 17.8914C18.9923 17.8914 22.7662 20.0901 25.496 23.719L28.2258 18.6031H30.6956V52.3798H28.2258Z",
  fill: "white"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M51.7661 52.3797H49.2962L35.2793 18.604H42.9532L50.5624 37.3687L58.1047 18.604H65.783L51.7661 52.3797Z",
  fill: "white"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M102.312 2.53342L102.314 2.5245C100.372 0.944875 97.9179 0 95.2684 0C88.9488 0 83.8262 5.10032 83.8262 11.3865C83.8262 13.9433 84.7208 16.2916 86.2257 18.1612C87.6168 18.1456 88.8116 18.4513 89.7196 18.8116C87.3167 17.1639 85.7472 14.4576 85.7472 11.3865C85.7472 6.20695 89.9673 2.00688 95.1736 2.00688C95.9177 2.00688 96.6439 2.09836 97.3389 2.26792C96.1174 3.03542 95.303 4.38636 95.303 5.93252C95.303 8.2618 97.2552 10.1359 99.6581 10.1359C102.003 10.1359 103.955 8.2618 103.955 5.93252C103.955 4.55481 103.303 3.32881 102.312 2.53342Z",
  fill: "#BBD422"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M81.8696 24.7877C79.3239 26.1309 77.3784 28.8629 77.3784 32.1627V52.3799H70.1641V18.6042H72.635L75.367 23.5238C77.7699 20.1593 81.5561 18.1747 85.7718 17.8947C89.2456 17.6649 91.6307 19.5446 91.6307 19.5446L88.6789 25.128C88.6778 25.1269 85.6636 22.7808 81.8696 24.7877Z",
  fill: "white"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M103.261 18.5896H96.0391V52.3686H103.261V18.5896Z",
  fill: "white"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M121.412 2.04028H114.195V52.3797H121.412V2.04028Z",
  fill: "white"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 72,
    viewBox: "0 0 122 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d28d024f.svg";
export { ForwardRef as ReactComponent };